import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizSelectors';

const HomePageImage:FC = () => {
  const quiz = useAppSelector(selectQuiz);

  const src = quiz?.landingPage?.image || '';

  if (!src) return null;
  return (
    <img
      src={src}
      alt="logo"
      className="h-32 w-32 mx-auto mt-8 object-contain rounded-full"
      style={{
        boxShadow: quiz.landingPage.imageShadowEnabled ? `0 0 20px ${quiz.theme.primaryColor}, 0 0 20px 4px ${quiz.theme.primaryColor}` : 'none',
        backgroundColor: quiz.landingPage.imageBackgroundColor || 'none',
      }}
    />
  )
}

export default HomePageImage;
